import { render, staticRenderFns } from "./PlayGame.vue?vue&type=template&id=25ec0647&scoped=true&"
import script from "./PlayGame.vue?vue&type=script&lang=js&"
export * from "./PlayGame.vue?vue&type=script&lang=js&"
import style0 from "./PlayGame.vue?vue&type=style&index=0&id=25ec0647&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec0647",
  null
  
)

export default component.exports